import { Link } from "react-router-dom";
import type { LibraryItemInfo } from "@/lib/api";

function record(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
}
function strings(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((entry): entry is string => typeof entry === "string") : [];
}
function TextSection({ title, text }: { title: string; text: unknown }) {
  if (typeof text !== "string" || !text) return null;
  return <section><h3 className="font-semibold text-studio-ink">{title}</h3><p className="mt-2 whitespace-pre-wrap">{text}</p></section>;
}
function ListSection({ title, values }: { title: string; values: unknown }) {
  const entries = strings(values);
  return entries.length ? <section><h3 className="font-semibold text-studio-ink">{title}</h3><ul className="mt-2 list-disc space-y-2 pl-5">{entries.map((entry) => <li key={entry}>{entry}</li>)}</ul></section> : null;
}
export function TechniqueGuide({ item }: { item: LibraryItemInfo }) {
  const guide = record(item.source_metadata.guide);
  const dive = record(item.source_metadata.deep_dive);
  if (!Object.keys(guide).length && !Object.keys(dive).length) return null;
  const sources = Array.isArray(guide.sources) ? guide.sources.map(record) : [];
  return <div className="mt-5 space-y-5 text-sm leading-6 text-studio-muted">
    <TextSection title="About this technique" text={item.description} />
    <TextSection title="Deep Dive: When to use" text={dive.when_to_use} />
    <ListSection title="Best practices" values={dive.best_practices} />
    <TextSection title="Guide: When to use" text={guide.when_to_use} />
    <TextSection title="Directing the AI" text={guide.directing_the_ai} />
    <ListSection title="Common mistakes" values={guide.common_mistakes} />
    <TextSection title="Attribution" text={guide.attribution} />
    {sources.length > 0 && <section><h3 className="font-semibold text-studio-ink">Sources</h3><ul className="mt-2 space-y-1">{sources.map((source) => typeof source.url === "string" && /^https:\/\//.test(source.url) ? <li key={source.url}><a className="text-studio-accent hover:underline" href={source.url} target="_blank" rel="noreferrer">{String(source.title ?? source.url)}</a></li> : null)}</ul></section>}
    <section><h3 className="font-semibold text-studio-ink">Related techniques</h3><div className="mt-2 flex flex-wrap gap-3">{strings(guide.related_ids).map((id) => <Link className="text-studio-accent hover:underline" key={id} to={`/library?source=${encodeURIComponent(item.source ?? "")}&technique=${encodeURIComponent(id)}`}>{id.replaceAll("-", " ")}</Link>)}</div></section>
  </div>;
}
